import React, { useContext, useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import { DriverAssistContext, DriverAssistProvider } from '@/v2/state/providers';
import { StateContext } from '@/v2/state/store';
import query from '@/v2/state/query';
import ScenesHandler from '@/v2/components/application/ScenesHandler';
import Scenes from './__scenes__';
import './DriverAssist.scss';

const onReady = () => {};

const DriverAssistComponent = ({ scenes }) => {
    const store = useContext(StateContext);
    const history = useHistory();

    useEffect(() => {
        const { dispatch } = store;
        dispatch({ type: 'ROUTE_LOAD' });
    }, []);

    const onFinished = () => {
        history.push('scenes.html#driverAssist');
    };

    return (
        <div className="DriverAssist">
            {scenes && (
                <ScenesHandler onReady={onReady} onFinished={onFinished}>
                    <Scenes.ProPilot data={scenes[0]} path="propilot" />
                    <Scenes.ProPilotActive data={scenes[1]} path="propilotactive" />
                    {/* <Scenes.ParkAssist data={scenes[2]} path="parkassist" /> */}
                    {/* <Scenes.ParkAssistPrologue data={scenes[3]} path="parkassistprologue" /> */}
                    <Scenes.ParkAssistActive data={scenes[4]} path="parkassistactive" />
                    <Scenes.RemoteParking data={scenes[5]} path="remoteparking" />
                    <Scenes.RemoteParkingPrologue data={scenes[6]} path="remoteparkingprologue" />
                    <Scenes.RemoteParkingActive data={scenes[7]} path="remoteparkingactive" />
                </ScenesHandler>
            )}
        </div>
    );
};

const DriverAssistRenderer = () => {
    const [data, setter] = useContext(DriverAssistContext);
    query(window.HELIOS.selectors.effortlessly, setter); // TODO: update key once corresponding AEM rename is done
    return <DriverAssistComponent scenes={data.scenes} />;
};

const DriverAssist = () => (
    <DriverAssistProvider>
        <DriverAssistRenderer />
    </DriverAssistProvider>
);

export default DriverAssist;
